import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Box, Flex, Image, Input, Progress, Spinner, Text } from '@chakra-ui/react';
import UploadIcon from './upload.svg';

function ImageUploaderRaw({ cloudName, uploadPreset, onImagesUpload, setLoading, loading, max, src, required }) {
  const [selectedImages, setSelectedImages] = useState([]);
  const [image, setImage] = useState("")

  useEffect(() => {
    if(selectedImages?.length > 0) {
        uploadImages(selectedImages)
    }
  }, [selectedImages])

  const handleImageChange = (e) => {
    const files = Array.from(e.target.files).slice(0, max);
    setSelectedImages(files);
    setImage(e.target.files[0])
  };

  const uploadImages = async () => {
    setLoading(true)
    const uploadedImageUrls = [];

    for (const image of selectedImages) {
        const formData = new FormData();
        formData.append('upload_preset', 'jmrkiyu0');
        formData.append('file', image);

        try {
            const response = await axios.post(
            `https://api.cloudinary.com/v1_1/declutters/image/upload`,
            formData
            );

            if (response.data && response.data.secure_url) {
            uploadedImageUrls.push(response.data.secure_url);
            }
        } catch (error) {
            console.error('Error uploading image: ', error);
        } finally {
            setLoading(false)
        }
    }
    onImagesUpload({urls: uploadedImageUrls, raw: selectedImages});
  };

  return (
    <Flex position={"relative"} height={"100px"} width={"100%"} alignItems={"center"} borderRadius={"8px"} border="1px dashed #D0D5DD" cursor={"pointer"} boxSizing='border-box' padding={"1rem"}>
      <Image src={UploadIcon} />
      {loading ? 
      <Text ml="1rem" color={"#344054"} fontSize={".9rem"} whiteSpace={"nowrap"}>Processing files <Spinner transform={"translateY(2px)"} ml=".3rem" size={"xs"} /></Text>
      :
      <Text ml="1rem" color={"#344054"} fontSize={".9rem"} whiteSpace={"nowrap"}>Upload files here {max < 10 && `(max ${max})`}</Text>}
      {!loading === true && <Input style={{height: "100%", cursor: "pointer", opacity: "0", position: "absolute", left: "0"}} type="file" multiple maxLength={2} accept="image/*" capture={src} onChange={handleImageChange} />}
      {/* <button onClick={uploadImages}>Upload Images</button> */}
    </Flex>
  );
}

export default ImageUploaderRaw;
